import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useSeo } from "@/lib/seo";
import { IMAGES, CONTACT_INQUIRIES } from "@/data/site";
import PageHero from "@/components/PageHero";
import { Reveal, Overline } from "@/components/Reveal";
import LeadForm from "@/components/LeadForm";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Contact() {
  useSeo("Contact | 12 Stone Development Group",
    "Contact 12 Stone Development Group for land submissions, data center development, investment, utility & infrastructure, builder/BTR, contractor, government / economic development and media inquiries.");
  const [contact, setContact] = useState({});
  useEffect(() => { api.get("/content/contact").then((r) => setContact(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageHero overline="Contact" title="Start a Conversation"
        subtitle="Tell us how you'd like to work with 12 Stone and the right person will follow up."
        image={IMAGES.substationNight} />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-20 grid lg:grid-cols-5 gap-12">
        <div className="lg:col-span-3">
          <Reveal>
            <Overline>Send a Message</Overline>
            <div className="mt-6 rounded-xl border border-border bg-card p-6 sm:p-8">
              <LeadForm leadType="contact" categoryOptions={CONTACT_INQUIRIES} defaultCategory="General Inquiry" submitLabel="SEND MESSAGE" testId="contact-form" />
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-2">
          <Reveal delay={0.1}>
            <Overline>Details</Overline>
            <div className="mt-6 rounded-xl border border-border bg-card p-7">
              <div className="font-display text-lg font-semibold text-foreground">{contact.company || "12 Stone Development Group LLC"}</div>
              <ul className="mt-6 space-y-5">
                <li className="flex items-start gap-3"><Mail className="h-5 w-5 text-primary mt-0.5" /><div><div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Email</div><div className="text-sm text-foreground">{contact.email || "Available on request"}</div></div></li>
                <li className="flex items-start gap-3"><Phone className="h-5 w-5 text-primary mt-0.5" /><div><div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Phone</div><div className="text-sm text-foreground">{contact.phone || "Available on request"}</div></div></li>
                <li className="flex items-start gap-3"><MapPin className="h-5 w-5 text-primary mt-0.5" /><div><div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Headquarters</div><div className="text-sm text-foreground">{contact.address || "Southeast United States"}</div></div></li>
              </ul>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
